export type TErrorResponse = { message: string | string[]; type: string; intercepted?: boolean };
